<template>
  <template v-if="json.type == 'Kiosk'">
    <OrderViewKiosk />
  </template>
  <template v-else>
    <OrderViewTable />
  </template>
</template>

<script>
/* eslint-disable */
import OrderViewKiosk from './components/OrderViewKiosk.vue'
import OrderViewTable from './components/OrderViewTable.vue'

export default {
  name: 'App',
  components: {
    OrderViewKiosk,
    OrderViewTable
  },
  data () {
    return {
      json: {},
    }
  },
  created () {
    this.json = new URL(location.href).searchParams.get('table')
    this.json = JSON.parse(atob(atob(this.json).substring(3)))
  },
  methods: {
  }
}
</script>

<style lang="scss">
  @import "./components/scss/OrderViewGenerals.scss";
</style>
<style>
  body {
    width: 100%;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
  }
  #app {
    width: 100%;
    height: 100%;
/*    font-family: 'Poppins', sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    margin-top: 0;
  }
</style>
